import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getPostAuthRedirect } from '@/features/auth/postAuthRedirect';
import { useAuthStore } from '@/store/authStore';

/** Redirects authenticated users away from login/register. */
export default function GuestRoute() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={getPostAuthRedirect(location.state)} replace />;
  }

  return <Outlet />;
}
